import { defineComponent, PropType } from 'vue';
import { NButton, NButtonGroup } from 'naive-ui';

import ComponentBase from '~/components/component-base';
import { TimeMode } from '~/models/mode.model';
import { DefaultMode } from '~/configs/mode.default.config';

export default defineComponent({

    extends: ComponentBase,

    components: {
    NButton,
    NButtonGroup,
},

    data() {
        return {
            isLoading: false,
            mode: null as TimeMode,
        }
    },

    props: {
        modes: { type: Array as PropType<TimeMode[]>, default: DefaultMode},
        title: { type: String },
        subtitle: { type: String},
        brand: { type: String },
    },

    mounted(): void {
        const mode = this.$route.query['mode'];
        if(!mode || !mode.length) {
            this.mode = this.modes.find((m: TimeMode) => m.default);
        } else {
            this.mode = this.modes.find((m: TimeMode) => m.name === mode);
        }
    },

    watch: {
        '$route.query.mode': {
            handler: function(mode: string) {
                this.mode = this.modes.find((tm: TimeMode) => tm.name === mode);
            },
            deep: true,
            immediate: true,
        }
    }
});